module.exports = __webpack_public_path__ + "static/iCloud_3-e8444ac95540da455ef51c622d7d003c.png";